/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CouponBatchDto } from './coupon-batch-dto';


export interface CouponInfoDto { 
    id: string;
    programId: string;
    name: string;
    slug: string;
    status: CouponInfoDto.StatusEnum;
    description?: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
    totalCodes: number;
    claimedCodes: number;
    batches: Array<CouponBatchDto>;
}
export namespace CouponInfoDto {
    export const StatusEnum = {
        Available: 'available',
        NotAvailable: 'not_available',
        Deleted: 'deleted'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


